import {
  CREATE_STUDENTS_FAILED,
  CREATE_STUDENTS_LOADED,
  CREATE_STUDENTS_LOADING,
  GET_ASSESSMENT_PROGRESS_FAILED,
  GET_ASSESSMENT_PROGRESS_LOADED,
  GET_ASSESSMENT_PROGRESS_LOADING,
  GET_MISSION_PROGRESS_FAILED,
  GET_MISSION_PROGRESS_LOADED,
  GET_MISSION_PROGRESS_LOADING,
  GET_PART_PROGRESS_FAILED,
  GET_PART_PROGRESS_LOADED,
  GET_PART_PROGRESS_LOADING,
  SET_CURRENT_CLASSROOM_LOADED,
  SET_CURRENT_MISSION_LOADED,
  SET_OPERATING_CLASSROOM_FAILED,
  SET_OPERATING_CLASSROOM_LOADED,
  SET_OPERATING_CLASSROOM_LOADING,
} from '../actions/classroom';

// mappers
const mapAssessmentProgress = ({ classroom_assessments = [], ...rest }) => {
  const totalScorePerQuestion = {};
  classroom_assessments.forEach(({ results = {} }) => {
    for (const [k, v] of Object.entries(results)) {
      if (totalScorePerQuestion[k]) {
        totalScorePerQuestion[k] += v ? 1 : 0;
        continue;
      }
      totalScorePerQuestion[k] = v ? 1 : 0;
    }
  });

  const parsedAssessments = classroom_assessments.map(({ student, ...restAssess }) => ({ ...restAssess, ...student }));

  return { classroom_assessments: parsedAssessments, ...rest, totalScorePerQuestion };
};

const mapPartProgress = (progresses = []) => {
  const progressesParsed = progresses.map(({ student, ...restProg }) => ({ ...restProg, ...student }));

  return [...progressesParsed];
};

// init state
const initialState = {
  id: null,
  currentMission: {},
  missionProgress: {},
  partProgress: [],
  assessmentTicket: {},
  isLoading: false,
  hasErrors: false,
  students: [],
  master_password: '',
  operatingClassroom: {},
};

// reducer
const reducer = (state = initialState, action) => {
  let parsedRes;
  switch (action.type) {
    case CREATE_STUDENTS_LOADING:
      return { ...state, students: [], isLoading: true, hasErrors: false };
    case GET_MISSION_PROGRESS_LOADING:
      return { ...state, missionProgress: {}, isLoading: true, hasErrors: false };
    case GET_PART_PROGRESS_LOADING:
      return { ...state, partProgress: [], isLoading: true, hasErrors: false };
    case GET_ASSESSMENT_PROGRESS_LOADING:
      return { ...state, assessmentTicket: {}, isLoading: true, hasErrors: false };
    case SET_CURRENT_CLASSROOM_LOADED:
      return { ...state, id: action.payload.id, name: action.payload.name };
    case SET_OPERATING_CLASSROOM_LOADED:
      return { ...state, operatingClassroom: action.payload };
    case CREATE_STUDENTS_LOADED:
      return { ...state, operatingClassroom: { ...state.operatingClassroom, ...action.payload } };
    case SET_CURRENT_MISSION_LOADED:
      return { ...state, currentMission: { ...action.payload } };
    case GET_MISSION_PROGRESS_LOADED:
      return { ...state, missionProgress: { ...action.payload.mission }, isLoading: false, hasErrors: false };
    case GET_PART_PROGRESS_LOADED:
      parsedRes = Object.values(action.payload).map((el) => el);
      return { ...state, partProgress: mapPartProgress(parsedRes), isLoading: false, hasErrors: false };
    case GET_ASSESSMENT_PROGRESS_LOADED:
      return {
        ...state,
        assessmentTicket: { ...mapAssessmentProgress(action.payload) },
        isLoading: false,
        hasErrors: false,
      };
    case GET_MISSION_PROGRESS_FAILED:
    case GET_PART_PROGRESS_FAILED:
    case CREATE_STUDENTS_FAILED:
    case GET_ASSESSMENT_PROGRESS_FAILED:
      return { ...state, isLoading: false, hasErrors: true };

    default:
      return state;
  }
};

export default reducer;
